import { Component, OnInit, Inject } from '@angular/core';
import { Location } from '@angular/common';
import { DataService } from '../services/data.service';
import { UserService } from '../services/user.service';
import { UserInfoService } from '../main/objects/user-info.service';
import { TokenService } from '../services/token.service';
import { FlashService } from '../services/flash.service';
import { Title } from '@angular/platform-browser';
import { ConstantsService } from '../services/constants.service';

declare var angular: any;

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss']
})
export class LoginComponent implements OnInit {

  id: string;
  loaded: boolean;
  metadata: any;
  fields: any;
  loginData: any;
  dataLoading: boolean;
  errorMsg: any;
  dirty: boolean;
  loginType: string;
  baseUrl: string;

  constructor(
    private dataService: DataService,
    private location: Location,
    private userService: UserService,
    private userInfo: UserInfoService,
    private tokenService: TokenService,
    @Inject('$rootScope') private $rootScope: angular.IRootScopeService & { [name: string]: any },
    private flashService: FlashService,
    private title: Title,
    private constants: ConstantsService,
    @Inject('BASE_URL') baseUrl: string) {
    this.baseUrl = baseUrl;
  }

  login($event, forcedSSOUsername: string = null) {

    if ($event) {
      $event.preventDefault();
    }

    var self = this;
    self.dataLoading = true;

    let userCredentials = {};

    if (!forcedSSOUsername || forcedSSOUsername.length === 0) {
      userCredentials = {
        "Username": self.fields[0].value,
        "Password": self.fields[1].value
      };
    } else {
      userCredentials = {
        "Username": forcedSSOUsername,
        "ForseSSOLogin": true
      };
    }

    self.userService.Login(userCredentials).then(function (response) {
      if (response.success && response.data.statusCode !== 400) {
        self.tokenService.SetToken(response.data.token);
        self.userService.GetUserDetails().then(function (userResponse) {
          if (userResponse.success) {
            self.userInfo.SetGlobalUserData(response.data);
            self.location.go('home');
            self.$rootScope.$broadcast('logedIn');
             self.userInfo.GetUserCredentialsStatus().then(function (statusResponse) {
              if (statusResponse && statusResponse.data && statusResponse.data.warnings && statusResponse.data.warnings.length > 0) {
                self.flashService.Alert(statusResponse.data.warnings.toString(), 'Alert', 'dismiss');
              }
             })
          } else {
            self.dataLoading = false;
          }
        });
      } else {
        self.dataLoading = false;
        self.errorMsg = response.data.error.errors.toString();
      }
    });
  }

  private loginWithIdToken(idToken) {
    var self = this;
    self.tokenService.SetToken(idToken);
    self.userService.GetUserDetails().then(function (userResponse) {
      if (userResponse.success) {
        // Set current login time to use by one login refresh.
        localStorage.setItem("loginTime", self.getDateString(new Date()));
        self.userInfo.SetGlobalUserData({ token: idToken });
        self.location.go('home');
        self.$rootScope.$broadcast('logedIn');
      } else {
        self.dataLoading = false;
      }
    });
  }

  private getDateString(date: Date): string {
    return `${date.getFullYear()}-${date.getMonth()}-${date.getDate()}-${date.getHours()}-${date.getMinutes()}`;
  }

  private getToken(hash: string): string {
    localStorage.clear();
    var pieces = hash.split('&');
    for (let kv of pieces) {
      var keyValue = kv.split("=");
      if (keyValue.length < 2) {
        continue;
      }
      localStorage.setItem("cayuse:" + keyValue[0], keyValue[1]);
    }

    return localStorage.getItem("cayuse:access_token");
  }

  ngOnInit() {
    // If id token is present in hash - try to log in with Cayse id token.
    var self = this;
    var token = this.getToken(window.location.hash);
    if (token) {
      this.loginWithIdToken(token);
      return;
    }
    this.id = 'login';
    if (!angular.isUndefined(this.$rootScope.globals.currentUser)) {
      this.location.go('home');
      return;
    }
    this.loaded = false;
    self.userService.GetLoginMetadata(self.id)
      .then(function (metadata) {
        self.metadata = metadata.data;
        self.fields = self.metadata.fields;
        self.userService.GetLoginData().then(function (result) {
          self.userInfo.SetLoginType(result.data.loginType);

          if (self.userInfo.GetLoginType() === self.constants.LoginTypes.Cayuse) {
            localStorage.clear();
            location.href = `${self.baseUrl}api/cayuse/auth?type=1`;
            return;
          }

          self.loginData = result.data;

          if (self.loginData.externalAuthenticationUserName) {
            self.userInfo.SetExternalAuthenticationLogoutURL(self.loginData.externalAuthenticationLogoutURL);

            self.login(null, self.loginData.externalAuthenticationUserName);
          }

          self.title.setTitle(result.data.tabName || self.constants.TabNames.Default);

          self.metadata.fields.forEach(function (item) {
            if (item.name === 'Username') {
              item.label = self.loginData.userNameLabel || 'User Name';
            }
            if (item.name === 'Password') {
              item.label = self.loginData.passwordLabel || 'Password';
            }
          });
          self.loaded = true;
        });
      });
  }
}

